<template>    
    <button v-bind="innerAttrs" :disabled="loadingState">
        <slot></slot>
    </button>
</template>

<script>
export default {
    inheritAttrs : false,
    data() {
        return {
            isLoading : false
        };
    },
    computed : {
        innerAttrs() {
            let attrs = {
                ...this.$attrs
            };

            if(attrs.onClick) {
                attrs.onClick = this.handleClick;
            }

            return attrs;
        },

        loadingState() {
            return this.isLoading;
        }
    },
    methods : {
        async handleClick(e) {
            this.isLoading = true;
            await this.$attrs.onClick(e);
            this.isLoading = false;
        }
    }
}
</script>

<style>

</style>